import * as Icons from "lucide-react";
import { WHY } from "@/data/content";
import { SectionHeading } from "./SectionHeading";

export const WhyADT = () => (
  <section id="why" className="border-t border-white/5 bg-black py-24">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        kicker="Чому ADT"
        title="Ваша перевага — мій досвід"
        subtitle="Чесна оцінка без прикрашання та прихованих проблем. Працюю для вашої впевненості на кожному етапі."
      />
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {WHY.map((item, i) => {
          const Icon = Icons[item.icon] || Icons.Check;
          return (
            <div
              key={item.title}
              data-testid={`why-card-${i}`}
              className="group rounded-md border border-white/10 bg-[#121212] p-8 transition-colors hover:border-[#B12A2A]/50"
            >
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-md bg-[#B12A2A]/10 text-[#B12A2A] transition-colors group-hover:bg-[#B12A2A] group-hover:text-white">
                <Icon className="h-6 w-6" strokeWidth={2} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-white">{item.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-white/60">{item.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
